import styled from 'styled-components';
import { BreadcrumbsTemplate } from './BreadcrumbsTemplate';
import { rem } from 'polished';

export const BreadcrumbsStyled = styled(BreadcrumbsTemplate)`
    a {
        cursor: pointer;
        &:not([tabindex='-1']) {
            &:focus-visible {
                text-decoration: underline;
            }
        }
        :hover {
            text-decoration: underline;
            ::before {
                text-decoration: none;
            }
        }
    }
    span,
    a {
        text-transform: uppercase;
        text-decoration: none;
        margin: 0 ${rem(4)};

        :first-child {
            margin-left: 0;

            ::before {
                content: '';
                margin: 0;
            }
        }
        ::before {
            display: inline-block;
            color: ${({ theme }) => theme.colors.secondary};
            content: '/';
            margin-right: 0.5rem;
        }
    }
`;
